import type { ComponentType } from "react";
import type { SlotKind } from "scantling-common";
import { Registry } from "scantling-common";

export interface SlotEditorProps {
  content: Uint8Array;
  update: (newContent: Uint8Array) => void;
  saveImmediately: (newContent: Uint8Array) => Promise<void>;
}

export interface SlotComponent {
  type: SlotKind;
  component: ComponentType<SlotEditorProps>;
}

export const slotRegistry = new Registry<SlotComponent>();

export function getSlotComponent(
  kind: SlotKind,
): ComponentType<SlotEditorProps> | undefined {
  const entry = slotRegistry.get(kind);
  return entry?.component;
}
